import { setupWorker } from 'msw';

import handlers from './handlers';

// Configure the static API Handlers
export const worker = setupWorker(...handlers);

export default worker;
